import { strictify } from '~/utils/strictify'
import { DashboardStoreReviewIndex } from '~/services/api/contracts/requests/DashboardStoreReviewIndex'
import { StoreReviewStoreReviews } from '~/services/api/contracts/requests/StoreReviewStoreReviews'
import {
  DashboardStoreReviewIndexSuccessSchema,
  StoreReviewApprovePathSchema,
  StoreReviewApproveSuccessSchema,
  StoreReviewRejectPathSchema,
  StoreReviewRejectSuccessSchema,
  StoreReviewStoreReviewsPathSchema,
  StoreReviewStoreReviewsSuccessSchema
} from '~/services/api/generated'
import type {
  DashboardStoreReviewIndexQuery,
  StoreReviewStoreReviewsQuery
} from '~/services/api/generated'

export function useReviewsService() {
  const baseURL = `${useRuntimeConfig().public.apiBaseUrl}/api/dashboard/reviews`
  const client = useApiRequest()

  return {
    list: async (query?: DashboardStoreReviewIndexQuery) => {
      const parsedQuery = DashboardStoreReviewIndex({}).parse(query ?? {})
      const response = strictify(DashboardStoreReviewIndexSuccessSchema).parse(
        await client(baseURL, { globalErrorUi: true, method: 'GET', query: parsedQuery })
      )
      return response
    },
    listByStore: async (storeId: number, query?: StoreReviewStoreReviewsQuery) => {
      const storePath = StoreReviewStoreReviewsPathSchema.strict().parse({ store: storeId })
      const parsedQuery = StoreReviewStoreReviews({}).parse(query ?? {})
      const response = strictify(StoreReviewStoreReviewsSuccessSchema).parse(
        await client(
          `${useRuntimeConfig().public.apiBaseUrl}/api/dashboard/stores/${storePath.store.toString()}/reviews`,
          {
            method: 'GET',
            query: parsedQuery
          }
        )
      )
      return response
    },
    approve: async (reviewId: number) => {
      const reviewPath = StoreReviewApprovePathSchema.strict().parse({ review: reviewId })
      const response = strictify(StoreReviewApproveSuccessSchema).parse(
        await client(`${baseURL}/${reviewPath.review.toString()}/approve`, {
          method: 'PUT'
        })
      )
      return response
    },
    reject: async (reviewId: number) => {
      const reviewPath = StoreReviewRejectPathSchema.strict().parse({ review: reviewId })
      const response = strictify(StoreReviewRejectSuccessSchema).parse(
        await client(`${baseURL}/${reviewPath.review.toString()}/reject`, {
          method: 'PUT'
        })
      )
      return response
    }
  }
}
